import { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, errMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { DeleteRecordButton } from "@/components/admin/DeletedRecords";
import { Loading, ErrorBox } from "@/components/common";
import { Take5Form } from "@/components/take5/Take5Form";
import { Take5View } from "@/components/take5/Take5View";

export default function Take5Page() {
  const { id } = useParams();
  const [doc, setDoc] = useState(null);
  const [refs, setRefs] = useState(null);
  const [error, setError] = useState("");
  const { user } = useAuth();
  const navigate = useNavigate();

  const load = useCallback(() => {
    setError("");
    setDoc(null);
    Promise.all([api.get(`/take5s/${id}`), api.get("/referentials")])
      .then(([d, r]) => { setDoc(d.data); setRefs(r.data); })
      .catch((e) => setError(errMessage(e)));
  }, [id]);
  useEffect(() => { load(); }, [load]);

  if (error) return <ErrorBox message={error} onRetry={load} />;
  if (!doc || !refs) return <Loading />;
  return (
    <div className="space-y-5">
      {doc.can_edit ? (
        <Take5Form key={doc.id} doc={doc} refs={refs} onDecided={setDoc} />
      ) : (
        <Take5View doc={doc} onChange={setDoc} />
      )}
      {user?.role === "admin" && navigator.onLine && !doc.read_only_participant && (
        <div className="flex justify-end"><DeleteRecordButton kind="take5" id={doc.id} onDeleted={() => navigate("/")} /></div>
      )}
    </div>
  );
}
